import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isSeries, truncateText } from 'helpers/ContentHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { useBoolean } from 'hooks';

import Modal from '../../../Modal';
import style from './Description.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    maxChars: 220,
  },
  [SITE_PLATFORM_WEB]: {
    maxChars: 220,
  },
  [SITE_PLATFORM_TABLET]: {
    maxChars: 120,
  },
  [SITE_PLATFORM_MOBILE]: {
    maxChars: 90,
  },
};

const Description = ({
  item = {},
  episode = {},
  breakpoint = SITE_PLATFORM_WEB,
  disableScroll,
}) => {
  const { value: showModal, setTrue, setFalse } = useBoolean(false);
  const modalRef = useRef();
  const { seriesType, description = '', shortDescription = '', longDescription = '' } = !_.isEmpty(
    episode,
  )
    ? episode
    : item;

  const data = isSeries(seriesType) && !_.isEmpty(episode) ? episode : item;
  const { id, name = '' } = data;

  const { global_moreButton: moreButtonLabel } = window.Language;

  const handleOverlayClick = e => {
    const { id: refId } = modalRef.current;
    const { id: targetId } = e.target;
    if (refId === targetId) modalCloseClickHandler();
  };

  const readMoreClickHandler = () => {
    setTrue();
    disableScroll({ disableScroll: true, bodyOnly: true, fixedPosition: true });
  };

  const modalCloseClickHandler = () => {
    setFalse(false);
    disableScroll({ disableScroll: false, bodyOnly: false, fixedPosition: false });
  };

  const selectedShortDescription = shortDescription || description || longDescription;

  const { maxChars } = BREAKPOINTS[breakpoint];
  const isLong = selectedShortDescription.length > maxChars;
  const truncatedDescription = truncateText(selectedShortDescription, maxChars);
  const readMore = isLong ? (
    <button
      className={style.readMore}
      onClick={readMoreClickHandler}
      type="button"
      aria-label={moreButtonLabel}
    >
      {moreButtonLabel}
    </button>
  ) : null;
  const modalProps = {
    description: selectedShortDescription,
    handleOverlayClick,
    id,
    handleCloseModal: modalCloseClickHandler,
    modalRef,
    name,
    showModal,
  };

  return (
    <div className={style.description}>
      {truncatedDescription}
      {readMore}
      <Modal {...modalProps} />
    </div>
  );
};

Description.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  item: PropTypes.shape({}),
  episode: PropTypes.shape({}),
  disableScroll: PropTypes.func.isRequired,
};
export default Description;
